import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const Error404 = () => {
  return (
    <>
      <Navbar isWhiteSlide={true} />
      <div className="h-screen flex flex-col items-center justify-center text-center px-4 font-['EB_Garamond','Nunito','sans-serif']">
        <h1 className="text-6xl font-bold text-[#EA7E5D] mb-4">404</h1>
        <h2 className="text-3xl font-semibold mb-2 text-gray-800">Page Not Found</h2>
        <p className="text-lg text-gray-600 mb-6">
          The page you’re looking for doesn’t exist or has been moved.
        </p>
        <Link
          to="/"
          className="text-white bg-[#EA7E5D] px-6 py-2 rounded hover:bg-[#d96a51] transition"
        >
          Go to Home
        </Link>
      </div>
    </>
  );
};

export default Error404;